import React from "react";

import {
    IFormUUID,
    IReviewsBrandID,
    IWebPageURL,
    isoProductUUID,
    isoReviewsProductID,
    isoReviewsProductVariantID,
} from "../../../models/nominals";
import { getInteger } from "../../../utils/numbers";
import { parseFacetValues } from "../../../utils/reviews";
import { useAppSelector } from "../../reducers";
import { defaultState } from "../defaults";
import { HeterogenousProductReviewForm } from "./HeterogenousProductReviewForm";
import { SingleProductWriteReviewForm } from "./SingleProductWriteReviewForm";

interface IProps {
    formUUID: IFormUUID;
    brandID: IReviewsBrandID;
    brand?: string;
    returnURL?: IWebPageURL;
}

export const SingleProductReviewSwitch = (props: IProps): React.ReactNode => {
    const facetValues = useAppSelector(
        (state) => (state.reviews || defaultState).ui.facetValues,
    );

    const productID = isoReviewsProductID.wrap(
        getInteger(facetValues.product_id, 0),
    );
    const variantIDs = parseFacetValues(facetValues.product_variant_id).map(
        (v) => isoReviewsProductVariantID.wrap(getInteger(v, 0)),
    );
    return variantIDs.length > 1 ? (
        <HeterogenousProductReviewForm
            parentUUID={isoProductUUID.wrap(String(props.formUUID))}
            productID={productID}
            variantIDs={variantIDs}
            returnURL={props.returnURL}
        />
    ) : (
        <SingleProductWriteReviewForm
            formUUID={props.formUUID}
            brandID={props.brandID}
            returnURL={props.returnURL}
        />
    );
};
